import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, Box } from '@stockx/ui';
import { SkeletonGridItems, SmartGridRow } from '@app/ui';
import { StyledModalProductsQuantityLabel } from './UserGeneratedContentModal.styles';
import UserGeneratedContentRelatedItems from './UserGeneratedContentRelatedItems';
import { useUserGeneratedContentProducts } from '../../hooks';

const UserGeneratedContentModalContent = ({
  entry,
  leftContainerHeight = 0,
}) => {
  const { t } = useTranslation();
  const maxHeight = leftContainerHeight * 0.68 - 24; // 24 for padding

  const { data, loading } = useUserGeneratedContentProducts(entry?.id);
  const products = data?.products ?? [];
  let productsQuantityLabel;
  if (products.length > 1) {
    productsQuantityLabel =
      'user_generated_content_collection_modal_shop_this_look_plural';
  } else {
    productsQuantityLabel =
      'user_generated_content_collection_modal_shop_this_look_singular';
  }

  if (loading) {
    return (
      <SmartGridRow columns={2}>
        <SkeletonGridItems items={2} />
      </SmartGridRow>
    );
  }

  return (
    <>
      <Box mt={1}>
        <Text fontWeight={500} fontSize="xl" color="grey.700" mt={4} mb={4}>
          {t('user_generated_content_collection_modal_shop_this_look')}
          <StyledModalProductsQuantityLabel>
            (
            {t(productsQuantityLabel, {
              ugcRelatedProducts: products.length,
            })}
            )
          </StyledModalProductsQuantityLabel>
        </Text>
      </Box>
      <Box
        overflowY="auto"
        overflowX="hidden"
        height={{ base: '100%' }}
        maxH={{ md: maxHeight }}
      >
        <SmartGridRow columns={2} isFullBleed>
          {products.map((product, idx) => (
            <UserGeneratedContentRelatedItems product={product} index={idx} />
          ))}
        </SmartGridRow>
      </Box>
    </>
  );
};

export default UserGeneratedContentModalContent;
